import { render } from "./switchPoliticas.vue?vue&type=template&id=5c4ff22c"
import script from "./switchPoliticas.vue?vue&type=script&lang=js"
export * from "./switchPoliticas.vue?vue&type=script&lang=js"

import "./switchPoliticas.vue?vue&type=style&index=0&id=5c4ff22c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__